export default __webpack_public_path__ + "static/media/circle-check-solid-red.010cf4d4.svg";